<template>
<q-modal :content-css="{ width: '80vw', minheight: '63%' }" v-model="showDlg" no-backdrop-dismiss	@show="loadSettings(); getState()">
  <q-modal-layout>
    <q-toolbar slot="header">
      <q-toolbar-title>
        {{$t('devicesetting')}} "{{ uuid }}"
      </q-toolbar-title>
      <q-btn
        flat
        round
        @click="closeDlg"
        icon="close"
      />
    </q-toolbar>

    <q-toolbar slot="footer">
      <q-toolbar-title>
      </q-toolbar-title>
      <q-btn
        color="secondary"
        :label="$t('closebtn')"
        @click="closeDlg"
      />
    </q-toolbar>

    <div class="doc-container">
      <div class="col-12" style = "padding:20px;">
        <q-field :label="$t('currstate')" style="font-size:10pt; float:left" label-width="10" class = "q-mr-md">
          <template v-if="is_online">
            <q-icon name="power" color = "primary" size="18pt" :title="$t('online')"/>
          </template>
          <template v-else>
            <q-icon name="power_off" color = "orange" size="18pt" :title="$t('offline')"/>                    
          </template>            
        </q-field>

        <q-field :label="$t('tempelectrode')+', C [36-43]:'" style="font-size:10pt;" label-width="3">
          <div class="row items-center no-wrap">
            <q-btn size="sm" round dense color="primary" icon="remove" @click="temp > 36?temp--:temp" class="q-mr-xs" />
            <q-input v-model="temp" style="font-size:10pt;width:30px;" suffix="C" readonly class="q-mr-xs"/>                            
            <q-btn size="sm" round dense color="primary" icon="add" @click="temp < 43?temp++:temp" class="q-mr-sm" />
          </div>            
        </q-field>

        <q-table
          color="primary"
          :data="deviceData"
          :columns="columns"
          row-key="uuid"
          :pagination.sync="pagination"
          hide-bottom
          dense
        >
        <template slot="body" slot-scope="props">
          <q-tr :props="props">
            <q-td key="course_number" :props="props">
              {{ props.row.__index + 1 }}
            </q-td>
            <q-td key="program_type" :props="props">
              {{ props.row.program_type | romanformat }}
              <q-popup-edit v-model="props.row.program_type" :title="$t('columns.programtype')"  buttons >
                <q-field>
                  <q-select v-model="props.row.program_type" :options="programs" :placeholder="$t('selectprogramm')" clearable clear-value="-" @clear="clearRow(props.row)"/>
                </q-field>                          
              </q-popup-edit>
            </q-td>
            <q-td key="amplitude1" :props="props">
              <template v-if="props.row.program_type!='-'">
              <div class="row items-center justify-between no-wrap">
                <q-btn size="sm" round dense color="primary" icon="remove" @click="props.row.amplitude1>0?props.row.amplitude1--:props.row.amplitude1" class="q-mr-xs" />
                <div>{{ props.row.amplitude1 }} {{$t('columns.voltage')}}
                  <q-popup-edit v-model="props.row.amplitude1" :title="$t('columns.amplitude') + ' [0-40]'"  buttons  :validate="val => checkRange(val,0,40)">
                    <q-field :error-label="$t('inputvalue') + ' ' + $t('from') + ' 0 ' + $t('to') + ' 40'" :error="!checkRange(props.row.amplitude1,0,40)">
                      <q-input type="number" v-model="props.row.amplitude1" @focus="$event.target.select()"/>
                    </q-field>                          
                  </q-popup-edit>
                </div>
                <q-btn size="sm" round dense color="primary" icon="add" @click="props.row.amplitude1<40?props.row.amplitude1++:props.row.amplitude1" class="q-mr-sm" />                  
              </div>                  
              </template>
              <template v-else>-</template>
            </q-td>
            <q-td key="frequency1" :props="props">
              <template v-if="props.row.program_type!='-'">
              <div class="row items-center justify-between no-wrap">
                <q-btn size="sm" round dense color="primary" icon="remove" @click="props.row.frequency1>1?props.row.frequency1--:props.row.frequency1" class="q-mr-xs" />
                <div>{{ props.row.frequency1 }} {{$t('columns.hz')}}
                  <q-popup-edit v-model="props.row.frequency1" :title="$t('columns.frequency') + ' [1-70]'"  buttons  :validate="val => checkRange(val,1,70)">
                    <q-field :error-label="$t('inputvalue') + ' ' + $t('from') + ' 1 ' + $t('to') + ' 70'" :error="!checkRange(props.row.frequency1,1,70)">
                      <q-input type="number" v-model="props.row.frequency1" @focus="$event.target.select()"/>
                    </q-field>                          
                  </q-popup-edit>
                </div>
                <q-btn size="sm" round dense color="primary" icon="add" @click="props.row.frequency1<70?props.row.frequency1++:props.row.frequency1" class="q-mr-sm" />                  
              </div>                  
              </template>
              <template v-else>-</template>
            </q-td>
            <q-td key="amplitude2" :props="props">
              <template v-if="props.row.program_type!='-'">
              <div class="row items-center justify-between no-wrap">
                <q-btn size="sm" round dense color="primary" icon="remove" @click="props.row.amplitude2>0?props.row.amplitude2--:props.row.amplitude2" class="q-mr-xs" />
                <div>{{ props.row.amplitude2 }} {{$t('columns.voltage')}}
                  <q-popup-edit v-model="props.row.amplitude2" :title="$t('columns.amplitude') + ' [0-40]'"  buttons  :validate="val => checkRange(val,0,40)">
                    <q-field :error-label="$t('inputvalue') + ' ' + $t('from') + ' 0 ' + $t('to') + ' 40'" :error="!checkRange(props.row.amplitude2,0,40)">
                      <q-input type="number" v-model="props.row.amplitude2" @focus="$event.target.select()"/>
                    </q-field>                          
                  </q-popup-edit>
                </div>
                <q-btn size="sm" round dense color="primary" icon="add" @click="props.row.amplitude2<40?props.row.amplitude2++:props.row.amplitude2" class="q-mr-sm" />                  
              </div>                  
              </template>
              <template v-else>-</template>
            </q-td>
            <q-td key="frequency2" :props="props">
              <template v-if="props.row.program_type!='-'">
              <div class="row items-center justify-between no-wrap">
                <q-btn size="sm" round dense color="primary" icon="remove" @click="props.row.frequency2>1?props.row.frequency2--:props.row.frequency2" class="q-mr-xs" />
                <div>{{ props.row.frequency2 }} {{$t('columns.hz')}}
                  <q-popup-edit v-model="props.row.frequency2" :title="$t('columns.frequency') + ' [1-25]'"  buttons  :validate="val => checkRange(val,1,25)">
                    <q-field :error-label="$t('inputvalue') + ' ' + $t('from') + ' 1 ' + $t('to') + ' 25'" :error="!checkRange(props.row.frequency2,1,25)">
                      <q-input type="number" v-model="props.row.frequency2" @focus="$event.target.select()"/>
                    </q-field>                          
                  </q-popup-edit>
                </div>
                <q-btn size="sm" round dense color="primary" icon="add" @click="props.row.frequency2<25?props.row.frequency2++:props.row.frequency2" class="q-mr-sm" />                  
              </div>                  
              </template>
              <template v-else>-</template>
            </q-td>
            <q-td key="time" :props="props">
              <template v-if="props.row.program_type!='-'">                
              {{ props.row.time }} {{$t('columns.min')}}
              <q-popup-edit v-model="props.row.time" :title="$t('columns.time')"  buttons >
                <q-field>
                  <q-select v-model="props.row.time" :options="times" :placeholder="$t('selectrange')"/>
                </q-field>                          
              </q-popup-edit>
              </template>
              <template v-else>-</template>
            </q-td>
            <q-td key="procedure_count" :props="props">
              <template v-if="props.row.program_type!='-'">
              <div class="row items-center justify-between no-wrap">
                <q-btn size="sm" round dense color="primary" icon="remove" @click="props.row.procedure_count>0?props.row.procedure_count--:props.row.procedure_count" class="q-mr-xs" />
                <div>{{ props.row.procedure_count }}
                  <q-popup-edit v-model="props.row.procedure_count" :title="$t('columns.procedurecount') + ' [0-200]'"  buttons  :validate="val => checkRange(val,0,200)">
                    <q-field :error-label="$t('inputvalue') + ' ' + $t('from') + ' 0 ' + $t('to') + ' 200'" :error="!checkRange(props.row.frequency1,0,200)">
                      <q-input type="number" v-model="props.row.procedure_count" @focus="$event.target.select()"/>
                    </q-field>                          
                  </q-popup-edit>
                </div>
                <q-btn size="sm" round dense color="primary" icon="add" @click="props.row.procedure_count<200?props.row.procedure_count++:props.row.procedure_count" class="q-mr-sm" />                  
              </div>                  
              </template>
              <template v-else>-</template>
            </q-td>
            <q-td key="savedevice" :props="props">
              <q-btn :title="$t('savedevicebtn')" icon="save_alt" color = "primary"  dense @click="set_param(props.row)" :disable="props.row.program_type=='-'"/>
            </q-td>

          </q-tr>
        </template>          
        </q-table>
        <div class="row items-center no-wrap justify-end">
          <q-btn :label="$t('savetemplatebtn')" color = "secondary" class = "q-ma-sm" @click="saveTemplate()"/>
          <q-btn-dropdown :label="$t('loadtemplatebtn')" color = "secondary" class = "q-ma-sm" @click="loadTemplates()">
            <q-list link>
              <template v-for="template in templates" >
              <q-item :key="template.name" @click.native="deviceData=template.procedures.data; temp = template.procedures.temp" v-close-overlay>
                <q-item-main>
                  <q-item-tile label>{{template.name}} ({{$t('medic')}}: {{ template.author_name }})</q-item-tile>
                </q-item-main>
              </q-item>
              </template>
            </q-list>
          </q-btn-dropdown>
          <q-btn :label="$t('clearbtn')" color = "secondary" class = "q-ma-sm" @click="clearSettings()"/>
          <q-btn :label="$t('loaddevicebtn')" color = "secondary" class = "q-ma-sm" @click="loadDevice()"/>
          <q-btn :label="$t('loadbtn')" color = "secondary" class = "q-ma-sm" @click="loadSettings()"/>
          <q-btn :label="$t('recbtn')" color = "secondary" class = "q-ma-sm" @click="saveSettings()"/>
        </div>
      </div>
    </div>
  </q-modal-layout>
</q-modal></template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      pagination: {
        sortBy: null, 
        descending: false,
        page: 1,
        rowsPerPage: -1 
      },
      columns: [
        { name: 'course_number', label: '№', field: 'course_number', align: 'center',  },
        { name: 'program_type', label: this.$t('columns.programtype'), field: 'program_type', align: 'center',  },
        { name: 'amplitude1', label: this.$t('columns.amplitude') + ' 1', field: 'amplitude1', align: 'center',  },
        { name: 'frequency1', label: this.$t('columns.frequency') + ' 1', field: 'frequence1', align: 'center',  },
        { name: 'amplitude2', label: this.$t('columns.amplitude') + ' 2', field: 'amplitude2', align: 'center',  },
        { name: 'frequency2', label: this.$t('columns.frequency') + ' 2', field: 'frequence2', align: 'center',  },
        { name: 'time', label: this.$t('columns.time'), field: 'time', align: 'center',  },
        { name: 'procedure_count', label: this.$t('columns.procedurecount'), field: 'procedure_count', align: 'center'  },
        { name: 'savedevice', label: this.$t('columns.savedevice'), field: 'savedevice', align: 'center'  },
      ],
      temp: 36,
      deviceData: [
        { program_type: '-', amplitude1: 0.0, frequency1: 1.0, amplitude2: 0.0, frequency2: 1.0, time: 0, procedure_count: 0  },
        { program_type: '-', amplitude1: 0.0, frequency1: 1.0, amplitude2: 0.0, frequency2: 1.0, time: 0, procedure_count: 0  },
        { program_type: '-', amplitude1: 0.0, frequency1: 1.0, amplitude2: 0.0, frequency2: 1.0, time: 0, procedure_count: 0  },
        { program_type: '-', amplitude1: 0.0, frequency1: 1.0, amplitude2: 0.0, frequency2: 1.0, time: 0, procedure_count: 0  },
        { program_type: '-', amplitude1: 0.0, frequency1: 1.0, amplitude2: 0.0, frequency2: 1.0, time: 0, procedure_count: 0  },
        { program_type: '-', amplitude1: 0.0, frequency1: 1.0, amplitude2: 0.0, frequency2: 1.0, time: 0, procedure_count: 0  }
      ],
      programs: [
        { label:this.$t('programm') + ' I', value: 1 }, 
        { label:this.$t('programm') + ' II', value: 2 },
        { label:this.$t('programm') + ' III', value: 3 },
        { label:this.$t('programm') + ' IV', value: 4 },
        { label:this.$t('programm') + ' V', value: 5 },
        { label:this.$t('programm') + ' VI', value: 6 },
      ],
      times: [
        { label:'1 ' + this.$t('columns.min'), value: 1 }, 
        { label:'5 ' + this.$t('columns.min'), value: 5 },
        { label:'10 ' + this.$t('columns.min'), value: 10 },
        { label:'15 ' + this.$t('columns.min'), value: 15 },
        { label:'20 ' + this.$t('columns.min'), value: 20 },
        { label:'25 ' + this.$t('columns.min'), value: 25 },
        { label:'30 ' + this.$t('columns.min'), value: 30 },
      ],
      templates: [],
      is_online: false
    }
  },

  props: {
    showDlg: null,
    uuid: null,
    device_type: null
  },     

  methods:
  {
    getState: function()
    {
      axios.get(`${this.$root.api_url}device/${this.uuid}/`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
        }
        }).then(({ data }) => {
        this.is_online = data.is_online
      })
      .catch (e =>{
        // eslint-disable-next-line
        console.log(e.response.data)
        switch (e.response.status) {
          case 401: this.$router.push('/auth'); break
          default: this.$q.notify({message: this.$t('error') + ': ' + e.response.statusText, type: 'negative', icon: 'report_problem' }); break
        }
      })
    },

    set_param: function(params)
    {
      // console.log(params)
      axios.get(`${this.$root.api_url}device/${this.uuid}/`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
        }
        }).then(({ data }) => {
          this.is_online = data.is_online
          if (!this.is_online)
          {
            this.$q.dialog({
              title: this.$t('errors.error'),
              message: this.$t('isoffline'),
              color: 'primary',
              ok: true
            })
            return
          } 
          else if (params.procedure_count < 1) {
            this.$q.dialog({
              title: this.$t('errors.error'),
              message: this.$t('errors.countempty'),
              color: 'primary',
              ok: true
            })
            return
          }
          else if (params.time == 0) {
            this.$q.dialog({
              title: this.$t('errors.error'),
              message: this.$t('errors.timeempty'),
              color: 'primary',
              ok: true
            })
            return
          }
          else {
            var request =  {
              program_type: params.program_type,
              amplitude1: params.amplitude1,
              amplitude2: params.amplitude2,
              frequency1: params.frequency1,
              frequency2: params.frequency2,
              temp: this.temp,
            }
            const requestStr = JSON.stringify(request)
            axios
              .post(`${this.$root.api_url}device/${this.uuid}/set_params/`, requestStr, {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'JWT ' + this.$store.state.token
                }
            }).then(() => {
              this.$q.notify({
                  message: this.$t('savesettingssucc'),
                  type: 'positive',
                  icon: 'thumb_up'
              })
            })
            .catch((e) => {
                // eslint-disable-next-line
                console.log(e.response.data)
                switch (e.response.status) {
                  case 403: this.$router.push('/auth'); break
                  default: this.$q.notify({message: this.$t('savesettingserr'), type: 'negative', icon: 'report_problem' }); break
                }
            })
          }
      })
      .catch (e =>{
        // eslint-disable-next-line
        console.log(e.response.data)
        switch (e.response.status) {
          case 401: this.$router.push('/auth'); break
          default: this.$q.notify({message: this.$t('error') + ': ' + e.response.statusText, type: 'negative', icon: 'report_problem' }); break
        }
      })
    },

    loadTemplates: function()
    {
      axios
        .get(`${this.$root.api_url}template/?device_type=${this.device_type}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
          }
      }).then((data) => {
        //console.log(data.data)
        this.templates = data.data
      })
      .catch((e) => {
          // eslint-disable-next-line
          console.log(e.response.data)
          switch (e.response.status) {
            case 403: this.$router.push('/auth'); break
            default: this.$q.notify({message: this.$t('savesettingserr'), type: 'negative', icon: 'report_problem' }); break
          }
      })

    },
    saveTemplate: function()
    {
      this.$q.dialog({
        title: this.$t('savetemplate'),
        message: this.$t('entertemplatename'),
        ok: this.$t('savebtn'),
        cancel: this.$t('cancelbtn'),
        prompt: {
            model: '',
            type: 'text' // optional
          },        
          }).then(data => {
          var request =  {
            name: data,
            device_type: this.device_type,
            procedures: 
            {
              temp: this.temp,
              data: this.deviceData
            }
          }
          const requestStr = JSON.stringify(request)
          axios
            .post(`${this.$root.api_url}template/`, requestStr, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'JWT ' + this.$store.state.token
              }
          }).then(() => {
            this.$q.notify({
                message: this.$t('savesettingssucc'),
                type: 'positive',
                icon: 'thumb_up'
            })
          })
          .catch((e) => {
              // eslint-disable-next-line
              console.log(e.response.data)
              switch (e.response.status) {
                case 403: this.$router.push('/auth'); break
                default: this.$q.notify({message: this.$t('savesettingserr'), type: 'negative', icon: 'report_problem' }); break
              }
          })
        }).catch(() => {
        })
    },

    clearSettings: function()
    {
      this.$q.dialog({
        title: this.$t('cleartitle'),
        message: this.$t('clearmessage'),
        ok: this.$t('yesbtn'),
        cancel: this.$t('nobtn'),
        }).then(() => {
          this.deviceData.forEach(row => {
            row.program_type = '-'
            this.clearRow(row)
          });
          this.temp = 36
        }).catch(() => {
        })
    },

    clearRow: function(row)
    {
      row.amplitude1 = 0.0
      row.amplitude2 = 0.0
      row.frequency1 = 1.0
      row.frequency2 = 1.0
      row.time = 0
      row.procedure_count = 0
    },

    saveSettings: function()
    {
      if (!this.is_online)
      {
        this.$q.dialog({
          title: this.$t('errors.error'),
          message: this.$t('isoffline'),
          color: 'primary',
          ok: true
        })
        return
      } 
      var request =  {
        uuid: this.uuid,
        temp: this.temp,
        data: this.deviceData
      }
      const requestStr = JSON.stringify(request)
      axios
        .post(`${this.$root.api_url}device/${this.uuid}/procedures/`, requestStr, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
          }
      }).then(() => {
        this.$q.notify({
            message: this.$t('savesettingssucc'),
            type: 'positive',
            icon: 'thumb_up'
        })
      })
      .catch((e) => {
          // eslint-disable-next-line
          console.log(e.response.data)
          switch (e.response.status) {
            case 403: this.$router.push('/auth'); break
            default: this.$q.notify({message: this.$t('savesettingserr'), type: 'negative', icon: 'report_problem' }); break
          }
      })
    },

    loadSettings: function()
    {
      axios
        .get(`${this.$root.api_url}device/${this.uuid}/procedures/`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
          }
      }).then((data) => {
        if (data.data.data)
        {
          this.temp = data.data.temp
          this.deviceData = data.data.data
          this.$q.notify({
            message: this.$t('loadsettingssucc'),
            type: 'positive',
            icon: 'thumb_up'
          })
        } else {
          this.deviceData.forEach(row => {
            row.program_type = '-'
            this.clearRow(row)
          });
          this.temp = 36
        }
      })
      .catch((e) => {
          // eslint-disable-next-line
          console.log(e.response.data)
          switch (e.response.status) {
            case 403: this.$router.push('/auth'); break
            default: this.$q.notify({message: this.$t('loadsettingserr'), type: 'negative', icon: 'report_problem' }); break
          }
      })
    },

    loadDevice: function() {
      axios
        .get(`${this.$root.api_url}device/${this.uuid}/proceduresdevice/`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
          }
      }).then((data) => {
        if (data.data.data)
        {
          this.temp = data.data.temp
          this.deviceData = data.data.data
          this.$q.notify({
            message: this.$t('loadsettingssucc'),
            type: 'positive',
            icon: 'thumb_up'
          })
        } else {
          this.deviceData.forEach(row => {
            row.program_type = '-'
            this.clearRow(row)
          });
          this.temp = 36
        }
      })
      .catch((e) => {
          // eslint-disable-next-line
          console.log(e.response.data)
          switch (e.response.status) {
            case 403: this.$router.push('/auth'); break
            default: this.$q.notify({message: this.$t('loadsettingserr'), type: 'negative', icon: 'report_problem' }); break
          }
      })
    },

    checkRange: function(value, min, max)
    {
      return value != null && value>=min && value<=max
    },
    closeDlg:function()
    {
      this.$emit('closeSettingsDlg');
    }
  },
  components: {  }

}
</script>

<style scoped>
table th td {
    word-break: break-all;
}
</style>
